import { RouteRoles } from '@/router/role-routes';
import { RouteConfig } from 'vue-router';
import { SoftwareLicenses } from '@/modules/software-licenses/types';

const routes: RouteConfig[] = [
  {
    path: `/${SoftwareLicenses.Pages.SOFTWARE_LICENSES}`,
    name: SoftwareLicenses.Pages.SOFTWARE_LICENSES,
    component: () => import(/* webpackChunkName: "software-licenses" */ './views/SoftwareLicenses.vue'),
    meta: {
      access_roles: RouteRoles[SoftwareLicenses.Pages.SOFTWARE_LICENSES],
    },
  },
  {
    path: `/${SoftwareLicenses.Pages.SOFTWARE_LICENSE_DETAIL}/:id`,
    name: SoftwareLicenses.Pages.SOFTWARE_LICENSE_DETAIL,
    component: () => import(/* webpackChunkName: "software-licenses-detail" */ './views/SoftwareLicenseDetail.vue'),
    meta: {
      access_roles: RouteRoles[SoftwareLicenses.Pages.SOFTWARE_LICENSE_DETAIL],
    },
  },
];

export default routes;
